// lazy-static-map.directive.ts
import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';
import { LazyLoadService } from './lazy-load.service';

@Directive({ selector: '[lazyStaticMap]' })
export class LazyStaticMapDirective implements AfterViewInit {
  @Input('lazyStaticMap') mapUrl!: string;
  constructor(
    private el: ElementRef<HTMLImageElement>,
    private loader: LazyLoadService
  ) {}

  ngAfterViewInit() {
    this.loader.observe(this.el.nativeElement, () => {
      this.el.nativeElement.src = this.mapUrl;
    });
  }
}
